import React from 'react'

const StatusThird = ({ color = '#1E1E1E' }: { color?: string }) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.65599 18.378C5.04599 19.203 5.88599 19.774 6.85999 19.774C7.83699 19.774 8.67899 19.199 9.06799 18.369M16.699 12.845L14.781 7.34301H12.115M18.222 9.50601V8.01201M18.781 12.386C16.404 12.386 14.418 14.062 13.94 16.296H13.942H10.938M10.938 16.296C10.938 14.043 9.11199 12.217 6.85899 12.217C4.60599 12.217 2.77999 14.043 2.77999 16.296H10.938ZM21.218 17.336C21.218 18.6819 20.1269 19.773 18.781 19.773C17.4351 19.773 16.344 18.6819 16.344 17.336C16.344 15.9901 17.4351 14.899 18.781 14.899C20.1269 14.899 21.218 15.9901 21.218 17.336ZM2.66699 4.22601H7.99999V9.55901H2.66699V4.22601Z'
        stroke={color}
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default StatusThird
